(function () {
  const MAP = {
    30: { min: 1, max: 1 },
    50: { min: 1, max: 2 },
    125: { min: 2, max: 4 },
    250: { min: 4, max: 6 },
    500: { min: 6, max: 10 },
    1000: { min: 10, max: 18 },
  };

  const BAR_MAX = 18;

  function extractGrams(text) {
    if (!text) return null;
    const m = String(text).match(/(\d+)\s*g/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function readVariantsJSON(sectionEl) {
    // In Split, the variants json is usually inside product-variants as application/json
    const jsonEl = sectionEl.closest('product-page')?.querySelector('product-variants script[type="application/json"]');
    if (!jsonEl) return null;
    try { return JSON.parse(jsonEl.textContent); } catch (e) { return null; }
  }

  function getSelectedVariantId(sectionEl) {
    const productPage = sectionEl.closest('product-page');
    if (!productPage) return null;
    const form = productPage.querySelector('product-form form');
    if (!form) return null;
    const idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function updateOne(root) {
    const productPage = root.closest('product-page');
    if (!productPage) return;

    const rangeEl = root.querySelector('[data-ec-servings-range]');
    const fillEl  = root.querySelector('[data-ec-servings-fill]');
    const gramsEl = root.querySelector('[data-ec-servings-grams]');

    const variants = readVariantsJSON(root) || [];
    const variantId = getSelectedVariantId(root);

    let title = null;
    if (variantId && Array.isArray(variants)) {
      const v = variants.find(x => String(x.id) === String(variantId));
      title = v?.title || null;
    }

    // fallback: try to find active label text (radio UI)
    if (!title) {
      const active = productPage.querySelector('.product-variant__input:checked');
      if (active) title = active.value;
    }

    const grams = extractGrams(title);
    if (!grams || !MAP[grams]) {
      root.style.display = 'none';
      return;
    }

    root.style.display = '';
    const cfg = MAP[grams];

    if (rangeEl) rangeEl.textContent = (cfg.min === cfg.max) ? String(cfg.min) : `${cfg.min}–${cfg.max}`;
    if (gramsEl) gramsEl.textContent = `${grams} g`;
    if (fillEl)  fillEl.style.width = `${Math.min(100, Math.round((cfg.max / BAR_MAX) * 100))}%`;
  }

  function updateAll() {
    document.querySelectorAll('[data-ec-servings-root]').forEach(updateOne);
  }

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  // Variant changes (radio/select)
  document.addEventListener('change', function (e) {
    // Only update if change occurs inside a product page
    if (e.target && e.target.closest && e.target.closest('product-page')) {
      updateAll();
    }
  });
})();
